import { useMemo } from "react";

import {STATUS_COLORS, STATUS_ORDER, STATUS_ORDER_INDEX_TO_COLOR_KEY} from "../../../../utils/constants";

export function statusToDisplay(status) {
    return status.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/^./, str => str.toUpperCase());
}

export function useBarChartData({
                                    byGroupData,
                                    selectedIndicator,
                                    groupLabelFormat = group => group
                                }) {
    return useMemo(() => {
        if (!selectedIndicator) return { labels: [], datasets: [] };
        const indicator_code = selectedIndicator.indicator_code;

        let groupKeys = Object.keys(byGroupData)
            .filter(key => key !== "National" && key !== "Global")
            .sort((a, b) => Number(a) - Number(b));

        const labels = [
            "National Avg.",
            "Global Avg.",
            ...groupKeys.map(groupLabelFormat)
        ];

        const datasets = STATUS_ORDER.map((status, index) => {
            const colorKey = !status || status === ""
                ? STATUS_ORDER_INDEX_TO_COLOR_KEY[index] 
                : status;
            return {
            label: status ? statusToDisplay(status) : "",
            backgroundColor: STATUS_COLORS[colorKey],
            data: [
                // National
                (() => {
                    const dist = byGroupData?.National?.[indicator_code]?.national;
                    return dist ? Math.round((dist[STATUS_ORDER.indexOf(status) + 1] ?? 0) * 100) : 0;
                })(),
                // Global
                (() => {
                    const dist = byGroupData?.Global?.[indicator_code]?.global;
                    return dist ? Math.round((dist[STATUS_ORDER.indexOf(status) + 1] ?? 0) * 100) : 0;
                })(),
                // Groups
                ...groupKeys.map(g => {
                    const dist = byGroupData?.[g]?.[indicator_code]?.school;
                    return dist ? Math.round((dist[STATUS_ORDER.indexOf(status) + 1] ?? 0) * 100) : 0;
                })
            ],
            stack: "main"
        };
        });

        return { labels, datasets };
    }, [byGroupData, selectedIndicator, groupLabelFormat]);
}